export {default as AssessmentFindings} from "./AssessmentFindings"
// export {default as InterventionsTab} from  "./InterventionsTab"
export {default as OPQRST} from "./OPQRST"
export {default as SampleTab} from "./SampleTab"
export {default as VitalsTab} from "./VitalsTab"
export {default as GeneralTab} from "./GeneralTab"
export {default as AirwayTab} from "./AirwayTab"
export {default as BreathingTab} from "./BreathingTab"
export {default as CirculationTab} from "./CirculationTab"
